/**
 * DynamicFontLoader Component
 *
 * Dynamically loads custom fonts from a URL (typically Google Fonts).
 * Prevents duplicate font loading and handles cleanup.
 */

import { useEffect } from 'react';

interface DynamicFontLoaderProps {
  /** URL to the font stylesheet (e.g., Google Fonts URL) */
  fontUrl?: string;
}

export function DynamicFontLoader({ fontUrl }: DynamicFontLoaderProps) {
  useEffect(() => {
    if (!fontUrl) {
      return;
    }

    // Check if font is already loaded (prevent duplicates)
    const existingLink = document.querySelector<HTMLLinkElement>(
      `link[href="${fontUrl}"]`
    );
    if (existingLink) {
      return;
    }

    // Create and append font stylesheet link
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = fontUrl;
    link.crossOrigin = 'anonymous'; // For external fonts (CORS)
    document.head.appendChild(link);

    // Cleanup: Remove font link on unmount
    // In practice, we usually want to keep fonts loaded
    return () => {
      // Optional: Remove link element
      // link.remove();
    };
  }, [fontUrl]);

  // This is a headless component - renders nothing
  return null;
}
